import { Stack, Typography } from "@mui/material";
export default function Botto() {
    return (
        <Stack>
            <Typography>Hello, this is about Spreezy Mart</Typography>
            <Typography>yadayadayada</Typography>
        </Stack>)
}

